

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";
import { getGunlukAracList } from "../joblist/jobListSlice";
import { toastApiError } from "../../helper/api/toastApiError";

const initialState = {

    isLoadingRegularDriverPhoneNumberQuery: false,

    queriedPhoneNumberForRegularDriver: "",
    regularDriverPhoneNumberQueryresponse: null,

    regularDriverPhoneNumberQueryStatus: null,

    allRegularDriversList: [],
    isLoadingGetAllRegularDrivers: false,

    regularDriverItemData: null,


    isLoadingGetRegularDriverDetails: false,


    isLoadingGetRegularDriverVehicles: false,
    regularDriverVehicles: [],

    isLoadingGetUserTcApproveV2: false,

    isTCApprove: false,

    isLoadingCreateRegularDriver: false,


    regularDriverData: null,

    isLoadingAddDriverToRegularDriversList: false,


    isLoadingJobListPhoneNumberOrNameQuery: false,

    jobListPhoneNumberOrNameQueryResults: [],

    isLoadingGetJobListDriverData: false,
    jobListDriverData: null,


    regularDriversAllRegularVehicles:[],

    dailyVehicleList: [],
    isLoadingGetDailyVehicleList: false,


    isLoadingGetTCQuery: false,
    queriedTCKN: {
      TCKN: "",
      isExist: null
    }

}


//! regularDriverPhoneNumberQuery
export const regularDriverPhoneNumberQuery = createAsyncThunk("regularDriverPhoneNumberQuery", async (phoneNumber, thunkApi) => {
    try {
      //! status 0 = kullanıcı veritabanında yok
      //! status 1 = kullanıcı veritabanında var ancak devamlıaraçlarda da var
      //! status 2 = kullanıcı var devamlıaraçlarda yok

      const { data } = await axiosInstance.get( `/DevamliAraclars/GetByDriverPhoneNumber?PhoneNumber=${phoneNumber}`);
      
      if(data.data.status === 0){
        thunkApi.dispatch(showModal("addRegularDriver"))
      }
      else if (data.data.status === 1){
       //! error
      }
      else if(data.data.status === 2){
        thunkApi.dispatch(showModal("addDriverPhoneNumberExistingDesc"))
      }
      
      return {data: data.data, phoneNumber, status: data.data.status};
    } catch (error) {
      const message = toastApiError(error, "Sürücü bilgisi alınamadı.");
      return thunkApi.rejectWithValue({ message });
    }
  }
);


export const createRegularDriver = createAsyncThunk("createRegularDriver", async ({regularData, phoneNumber}, thunkApi) => {
    try {
      const { data } = await axiosInstance.post( `/DevamliAraclars/CreateNewDriverFromClient`, regularData);
          if(data.statusCode === 200){
            thunkApi.dispatch(showModal("addDriverAfterVehicleQuestion"))
            thunkApi.dispatch(getAllRegularDrivers())

          }
          else{
            const message = toastApiError(data, "Sürücü eklenemedi.")
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: message, resultType: "error", btnText1: "Tamam"}))
          }
      return data;
    } catch (error) {
      const message = toastApiError(error, "Sürücü eklenemedi.");
      return thunkApi.rejectWithValue({ message });
    }
  }
);


export const createRegularVehicle = createAsyncThunk("createRegularVehicle", async (regularVehicle, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post( `/DevamliAraclars/AddTruckTrailerFromClientV2`, regularVehicle);
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Araç ekleme işlemi başarı ile gerçekleştirildi", resultType: "success", btnText1: "Tamam"}))
        thunkApi.dispatch(getAllRegularDrivers())

      }
      else{
        toastApiError(data, "Araç eklenemedi.")
      }
      // else{

      //   thunkApi.dispatch(showModal("result"))
      //   thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Tamam"}))
      // }
      
      return data;
    } catch (error) {
      const message = toastApiError(error, "Araç eklenemedi.");
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getAllRegularDrivers = createAsyncThunk("getAllRegularDrivers", async (_, thunkApi) => {
    try {

      const { data } = await axiosInstance.get( `/DevamliAraclars/GetAllContinuousVehicles`);
      
      return data;
    } catch (error) {
      const message = toastApiError(error, "Sürücüler alınamadı.");
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getRegularDriverDetails = createAsyncThunk("getRegularDriverDetails", async (phoneNumber, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`DevamliAraclars/GetUserDetailsWithDocuments?phoneNumber=${phoneNumber}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const getRegularDriverVehicles = createAsyncThunk("getRegularDriverVehicles", async (phoneNumber, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`DevamliAraclars/GetVehicleListWithDocuments?phoneNumber=${phoneNumber}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const getUserTcApproveV2 = createAsyncThunk("getUserTcApproveV2", async (approveData, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`user/UserTcApproveV2`, approveData);
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const addDriverToRegularDriversList = createAsyncThunk("addDriverToRegularDriversList", async (approveData, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`DevamliAraclars/AddDriverToList`, approveData);
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(getAllRegularDrivers())
        thunkApi.dispatch(setResultModalData({msg: "İlgili sürücü, sürücülerinize başarı ile eklendi.", resultType: "success", btnText1: "Tamam"}))
      }
      else{
        const message = toastApiError(data, "Sürücü güncellenemedi.")
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: message, resultType: "error", btnText1: "Tamam"}))
      }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const deleteRegularDriver = createAsyncThunk( "deleteRegularDriver", async (param, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.delete( `/DevamliAraclars/Delete?Id=${param}`);
      

      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "İlgili sürücü, sürücülerinizden  başarı ile silindi.", resultType: "success", btnText1: "Tamam"}))
        thunkApi.dispatch(getAllRegularDrivers())
      }
      
      else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Tamam"}))
      }

      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const updateRegularDriverData = createAsyncThunk("updateRegularDriverData", async (param, thunkApi) => {
    try {
      const { data } = await axiosInstance.post( `/DevamliAraclars/Update`, param);
      if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Güncelleme işlemi başarı ile gerçekleştirildi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
        thunkApi.dispatch(getAllRegularDrivers())
      }
      else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Tamam"}))
      }
      return data.data;
    } catch (error) {
      const message = toastApiError(error, "Sürücü güncellenemedi.");
      return thunkApi.rejectWithValue({ message });
    }
  }
);


//! ***************** jobList

export const jobListPhoneNumberOrNameQuery = createAsyncThunk("jobListPhoneNumberOrNameQuery", async (value, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/DevamliAraclars/SearchUserByPhoneOrName?value=${value}`);
      
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const getJobListDriverData = createAsyncThunk("getJobListDriverData", async (param, thunkApi) => {
    try {
      const { data } = await axiosInstance.get( `/GunlukAracListesi/GetByDriverPhoneNumber?PhoneNumber=${param}`);

      //! isReference 1 ise kendi aracı 0 ise işverenin aracı

      if(data.data.phoneNumber){
        thunkApi.dispatch(showModal("addDailyQueue"))
      }
      
      // if (data.statusCode === 200) {
      //   thunkApi.dispatch(showModal("result"));
      //   thunkApi.dispatch(
      //     setResultModalData({
      //       msg: "Güncelleme işlemi başarı ile gerçekleştirildi.",
      //       resultType: "success",
      //       btnText1: "Listeyi Görüntüle",
      //     })
      //   );
      // }
      // else{
      //   thunkApi.dispatch(showModal("result"))
      //   thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Tamam"}))
      // }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);



export const addDriverToDailyVehicle = createAsyncThunk("addDriverToDailyVehicle", async (body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/GunlukAracListesi/AddDriverToDailyVehicle`, body);
            if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(getGunlukAracList({Plate:"", CityCanGo: "", TruckType:  "", Star: "" }))
        thunkApi.dispatch(
          setResultModalData({
            msg: "Sıraya ekleme işlemi başarı ile gerçekleştirildi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
      }
 
      else{
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Tamam"}))
      }
      return data.data;
    } catch (error) {
      const message = toastApiError(error, "Sürücü sıradaki araca eklenemedi.");
      return thunkApi.rejectWithValue({ message });
    }
  }
);


//! burası şimdilik kullanılmıyoe
export const getDailyVehicleList = createAsyncThunk("getDailyVehicleList", async ({Plate = "", CityCanGo = "", TruckType = "", Star = ""}, thunkApi) => {
    try {
      const {data} = await axiosInstance.get(`/GunlukAracListesi/GetAll?Star=${Star}&Plate=${Plate}&CityCanGo=${CityCanGo}&TruckType=${TruckType}`)
      
      return data.data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


export const getTCQuery = createAsyncThunk("getTCQuery", async (TCKN, thunkApi) => {
    try {
      const {data} = await axiosInstance.get(`/user/VerifyNationalId?TCKN=${TCKN}`)
      
      return {
        isExist: data.data.isExist,
        TCKN 
      }
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})



const driversVehiclesSlice = createSlice({
    name:"driversVehicles",
    initialState,
    reducers:{
      setIsTcApprove: (state, action) => {
        state.isTCApprove = action.payload
      },

      //! ... nokta ile deavmli sürücünün referans ve devamli güncellemesini modala taşımak için
      setRegularDriverData: (state,action) => {
        state.regularDriverData = action.payload
      }, 

      setRegularDriverPhoneNumberQueryStatus: (state,action) => {
        state.regularDriverPhoneNumberQueryStatus = action.payload
      },


      setRegularDriversAllRegularVehicles: (state, action) => {
        state.regularDriversAllRegularVehicles = action.payload
      },

      setJobListPhoneNumberOrNameQueryResults: (state,action) => {
        state.jobListPhoneNumberOrNameQueryResults = action.payload
      }
      

    },
    extraReducers: (builder) => {
        builder
        .addCase(regularDriverPhoneNumberQuery.pending, (state) => {
            state.isLoadingRegularDriverPhoneNumberQuery = true
        })
        .addCase(regularDriverPhoneNumberQuery.fulfilled, (state, action) => {
            state.isLoadingRegularDriverPhoneNumberQuery = false
            state.queriedPhoneNumberForRegularDriver = action.payload.phoneNumber
            state.regularDriverPhoneNumberQueryresponse = action.payload.data
            state.regularDriverPhoneNumberQueryStatus = action.payload.status
        })
        .addCase(regularDriverPhoneNumberQuery.rejected, (state) => {
            state.isLoadingRegularDriverPhoneNumberQuery = false
        })

        .addCase(getAllRegularDrivers.pending, (state) => {
            state.isLoadingGetAllRegularDrivers = true
        })
        .addCase(getAllRegularDrivers.fulfilled, (state, action) => {
            state.isLoadingGetAllRegularDrivers = false
            state.allRegularDriversList = action.payload.data.items.$values
        })
        .addCase(getAllRegularDrivers.rejected, (state) => {
            state.isLoadingGetAllRegularDrivers = false
        })


        .addCase(createRegularDriver.pending, (state) => {
            state.isLoadingCreateRegularDriver = true
        })
        .addCase(createRegularDriver.fulfilled, (state, action) => {
            state.isLoadingCreateRegularDriver = false
        })
        .addCase(createRegularDriver.rejected, (state) => {
            state.isLoadingCreateRegularDriver = false
        })


        .addCase(getRegularDriverDetails.pending, (state) => {
            state.isLoadingGetRegularDriverDetails = true
        })
        .addCase(getRegularDriverDetails.fulfilled, (state, action) => {
            state.isLoadingGetRegularDriverDetails = false
            state.regularDriverItemData = action.payload.data
        })
        .addCase(getRegularDriverDetails.rejected, (state) => {
            state.isLoadingGetRegularDriverDetails = false
        })


        .addCase(getRegularDriverVehicles.pending, (state) => {
            state.isLoadingGetRegularDriverVehicles = true
        })
        .addCase(getRegularDriverVehicles.fulfilled, (state, action) => {
            state.isLoadingGetRegularDriverVehicles = false
            state.regularDriverVehicles = action.payload.data.$values
        })
        .addCase(getRegularDriverVehicles.rejected, (state) => {
            state.isLoadingGetRegularDriverVehicles = false
        })

        
        .addCase(getUserTcApproveV2.pending, (state) => {
            state.isLoadingGetUserTcApproveV2 = true
            state.isTCApprove = false
        })
        .addCase(getUserTcApproveV2.fulfilled, (state, action) => {
            state.isLoadingGetUserTcApproveV2 = false
            state.isTCApprove = action.payload.userTcApprove
        })

        .addCase(getUserTcApproveV2.rejected, (state) => {
            state.isLoadingGetUserTcApproveV2 = false
            state.isTCApprove = false

        })



        .addCase(addDriverToRegularDriversList.pending, (state) => {
            state.isLoadingAddDriverToRegularDriversList = true
        })
        .addCase(addDriverToRegularDriversList.fulfilled, (state, action) => {
            state.isLoadingAddDriverToRegularDriversList = false
        })

        .addCase(addDriverToRegularDriversList.rejected, (state) => {
            state.isLoadingAddDriverToRegularDriversList = false

        })


        .addCase(jobListPhoneNumberOrNameQuery.pending, (state) => {
            state.isLoadingJobListPhoneNumberOrNameQuery = true
        })
        .addCase(jobListPhoneNumberOrNameQuery.fulfilled, (state, action) => {
            state.isLoadingJobListPhoneNumberOrNameQuery = false
            state.jobListPhoneNumberOrNameQueryResults = action.payload.$values
        })

        .addCase(jobListPhoneNumberOrNameQuery.rejected, (state) => {
            state.isLoadingJobListPhoneNumberOrNameQuery = false

        })

        .addCase(getJobListDriverData.pending, (state) => {
            state.isLoadingJobListPhoneNumberOrNameQuery = true
        })
        .addCase(getJobListDriverData.fulfilled, (state, action) => {
            state.isLoadingJobListPhoneNumberOrNameQuery = false
            state.jobListDriverData = action.payload
        })

        .addCase(getJobListDriverData.rejected, (state) => {
            state.isLoadingJobListPhoneNumberOrNameQuery = false

        })

        .addCase(getDailyVehicleList.pending, (state) => {
            state.isLoadingGetDailyVehicleList = true
        })
        .addCase(getDailyVehicleList.fulfilled, (state, action) => {
            state.isLoadingGetDailyVehicleList = false
            state.dailyVehicleList = action.payload.$values
        })

        .addCase(getDailyVehicleList.rejected, (state) => {
            state.isLoadingGetDailyVehicleList = false

        })
        
        
        .addCase(getTCQuery.pending, (state) => {
          state.isLoadingGetTCQuery = true
          
        })
        .addCase(getTCQuery.fulfilled, (state, action) => {
          state.isLoadingGetTCQuery = false
          state.queriedTCKN = action.payload
        })

        .addCase(getTCQuery.rejected, (state) => {
          state.isLoadingGetTCQuery = false
        })
        

        

        
    }
})

export const {
  setIsTcApprove,
  setRegularDriverData,
  setRegularDriverPhoneNumberQueryStatus,
  setRegularDriversAllRegularVehicles,
  setJobListPhoneNumberOrNameQueryResults
} = driversVehiclesSlice.actions
export default driversVehiclesSlice.reducer
